import { CookieRepository } from './cookie.repository'
import { LocalStorageRepository } from './local-storage.repository'
import { SessionStorageRepository } from './session-storage.repository'
import { type Config, StorageStrategy } from './storage.constants'
import type { StorageInterface } from './storage.interface'

export class StorageFactory {
  create(strategy: StorageStrategy, config?: Config): StorageInterface {
    if (strategy === StorageStrategy.Cookie && !config) {
      throw new Error('Config must be provided for cookie storage')
    }

    if (strategy === StorageStrategy.Cookie && !!config) {
      return new CookieRepository(config)
    }

    if (strategy === StorageStrategy.LocalStorage) {
      return new LocalStorageRepository()
    }

    if (strategy === StorageStrategy.SessionStorage) {
      return new SessionStorageRepository()
    }

    throw new Error('Invalid storage strategy')
  }
}
